import React from "react";
import { useTheme } from "../Theme/ThemeProvider";
import { Wrapper } from "./styles";

export default function WhySection({ toggleQrModal }) {
  const { isDarkMode } = useTheme();
  return (
    <Wrapper>
      <div className="content">
        <div className="left-content">
          <div className="title">
            Por que escolher a <span>Primatio</span>?
          </div>
          <div className="description">
            Com anos de experiência desenvolvendo Apps para diversos projetos e
            empresas renomadas, a Primatio pode proporcionar segurança e
            tecnologia de ponta para sua empresa.
          </div>
        </div>

        <div className="right-content">
          {[...Array(12)].map((_, i) => {
            const index = i + 1;
            const themeFolder = isDarkMode ? "dark" : "light";
            const imageName = `part-${index}-${themeFolder}.png`;

            return (
              <img
                key={index}
                src={`/assets/${themeFolder}/${imageName}`}
                alt={`Parte ${index}`}
              />
            );
          })}
        </div>
      </div>
    </Wrapper>
  );
}
